import React from 'react'

export const isUndefined = (record: any): any | string => {
  if (record === null ||
    record === undefined ||
    record === ''
  ) {
    return '-'
  }

  if (typeof record === 'object' && !React.isValidElement(record)) {
    return '-'
  }

  return record
}
